import React from "react";
import heroImage from "./assets/micuenta-banner-panoramico.jpg";

const BANNER_BG = "rgb(14, 15, 28)";
const TOP_FADE =
  "linear-gradient(to bottom, rgba(14, 15, 28, 0.7) 0%, rgba(14, 15, 28, 0) 30%)";
const BOTTOM_FADE =
  "linear-gradient(to top, #0c0e14 0%, rgba(12, 14, 20, 0.5) 40%, rgba(12, 14, 20, 0) 100%)";

export const MiCuentaBanner = () => {
  return (
    <div className="w-full relative" aria-hidden="true">
      {/* Fondo del navbar (transparente): mantiene el offset de la barra fija */}
      <div className="h-[82px] w-full" style={{ backgroundColor: BANNER_BG }} />
      <div
        className="w-full h-[220px] desktop:h-[300px]"
        style={{
          width: "100%",
          backgroundColor: BANNER_BG,
          backgroundImage: `${BOTTOM_FADE}, ${TOP_FADE}, url(${heroImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center 30%",
          backgroundRepeat: "no-repeat",
        }}
      />
    </div>
  );
};

export default MiCuentaBanner;
